import { render } from "./ProductStockComponent.vue?vue&type=template&id=aba7aa40&scoped=true"
import script from "./ProductStockComponent.vue?vue&type=script&lang=js"
export * from "./ProductStockComponent.vue?vue&type=script&lang=js"

import "./ProductStockComponent.vue?vue&type=style&index=0&id=aba7aa40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba7aa40"]])

export default __exports__